import {actions} from './actions';

const NotifierReducers = {
  [actions.SHOW_NOTIFICATION]: (state, action) => {return { ...state, notification: action.notification}},
  [actions.REMOVE_NOTIFICATION]: (state) => {return { ...state, notification:{message:'', variant:'success', open:false}}},
}

export default NotifierReducers;